import axios from "axios";

let baseURL = "https://loc.waizmann089.de";

if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "loc.waizmann089.de"
) {
  baseURL = "https://loc.waizmann089.de";
}

if (
  window.location.hostname === "www.waizmann089.de" ||
  window.location.hostname === "waizmann089.de"
) {
  baseURL = window.location.origin;
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
